var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-callback-container"},[_c('div',{staticClass:"minimal-loading"},[_c('div',{staticClass:"loading-spinner"}),_c('p',[_vm._v("Verifying authentication...")])])])
}]

export { render, staticRenderFns }